import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { userAcceptWfoeToS } from 'researcher/user/actions';
import { addMessage } from 'researcher/application/actions';
import ModalFlashMessage from 'shared/components/ModalFlashMessage';
var WfoeMigrationStatus = function WfoeMigrationStatus() {
  var userInMigratingGroup = useSelector(function (_ref) {
    var user = _ref.user;
    return user.wfoeMigrationStatus.inMigratingGroup;
  });
  var userAcceptedWfoeToS = useSelector(function (_ref2) {
    var user = _ref2.user;
    return user.wfoeMigrationStatus.acceptedTermsOfService;
  });
  var userFinishedWfoeMigration = useSelector(function (_ref3) {
    var user = _ref3.user;
    return user.wfoeMigrationStatus.migrated;
  });
  var userIdentity = useSelector(function (_ref4) {
    var user = _ref4.user;
    return user.identity;
  });
  var dispatch = useDispatch();
  var onSubmit = function onSubmit() {
    dispatch(userAcceptWfoeToS(userIdentity)).then(function (error) {
      if (error) {
        dispatch(addMessage({
          type: 'error',
          message: error
        }));
      }
    });
  };
  if (!userInMigratingGroup || userAcceptedWfoeToS && userFinishedWfoeMigration) {
    return /*#__PURE__*/React.createElement(Navigate, {
      replace: true,
      to: "/researcher"
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, !userAcceptedWfoeToS ? /*#__PURE__*/React.createElement(ModalFlashMessage, {
    message: {
      message: 'wfoe-tos',
      type: 'wfoe-tos-popup-header',
      action: {
        text: 'wfoe-tos-accept-button',
        link: false
      }
    },
    dismissMessage: onSubmit
  }) : /*#__PURE__*/React.createElement(ModalFlashMessage, {
    message: {
      message: 'wfoe-migration-check-back-later',
      type: 'wfoe-tos-popup-header'
    },
    dismissMessage: null
  }));
};
export default WfoeMigrationStatus;